import React from 'react';
import Icon from '../../../components/AppIcon';

const RecommendationCard = ({ recommendation }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'error';
      case 'medium': return 'warning';
      case 'low': return 'success';
      default: return 'muted';
    }
  };

  const getPriorityIcon = (priority) => {
    switch (priority) {
      case 'high': return 'AlertCircle';
      case 'medium': return 'AlertTriangle';
      case 'low': return 'Info';
      default: return 'Info';
    }
  };

  return (
    <div className="p-4 bg-muted/30 rounded-lg border border-border hover:border-success/50 transition-smooth">
      <div className="flex items-start gap-3 mb-2">
        <div className={`
          w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0
          bg-${getPriorityColor(recommendation?.priority)}/10
        `}>
          <Icon 
            name={getPriorityIcon(recommendation?.priority)} 
            size={16} 
            color={`var(--color-${getPriorityColor(recommendation?.priority)})`}
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="font-body font-semibold text-sm text-foreground">
              {recommendation?.title}
            </h4>
            <span className={`
              px-2 py-0.5 rounded text-xs font-medium capitalize
              bg-${getPriorityColor(recommendation?.priority)}/10 text-${getPriorityColor(recommendation?.priority)}
            `}>
              {recommendation?.priority}
            </span>
          </div>
          <p className="caption text-muted-foreground mb-2">
            {recommendation?.description}
          </p>
          {recommendation?.expectedImpact && (
            <div className="flex items-start gap-2 mt-2 pt-2 border-t border-border">
              <Icon name="Target" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
              <p className="caption text-foreground">
                <span className="font-medium">Expected Impact:</span> {recommendation?.expectedImpact}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;
